import { Injectable, ErrorHandler, InjectionToken, Inject } from "@angular/core";
import * as Rollbar from "rollbar";
import { environment } from "src/environments/environment";
import { StorageService } from "./storageservice";
import { RollbarError } from 'src/shared/entities/rollbarError.class';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { App  } from "@capacitor/app";
import { Observable } from 'rxjs';
// const { Device } = Plugins;
  
const rollbarConfig: Rollbar.Configuration = {
    // accessToken: '293ccc2cefeb426cbce0b6fa39a0e788',
    // autoInstrument: { network: true, log: true, dom: true, navigation: true, connectivity: true },
    // captureUncaught: true,
    // captureUnhandledRejections: true,
    // captureEmail: true,
    // captureIp: true,
    // captureUsername: true,
    // environment: environment.production ? "production" : "development",
    // enabled: environment.production ? true : false,
    // ignoredMessages: ["Script error."],
    // code_version: environment.build_VersionNumber,
    // payload: {
    //     environment: environment.production ? "production" : "development",
    //     client: {
    //         javascript: {
    //             code_version: environment.build_VersionNumber,
    //             source_map_enabled: true,
    //             guess_uncaught_frames: true,
    //         },
    //     },
    // },
    // //endpoint: environment.serviceUrl + "Business/ErrorLoggingRollbar",
    // endpoint: 'https://api.rollbar.com/api/1/item/',
};
  
export const RollbarService = new InjectionToken<Rollbar>("rollbar");
  
@Injectable({
    providedIn: "root",
})
export class RollbarErrorHandler implements ErrorHandler {
    public readonly cacheLoggerKey = "CacheLogger";
    lastWarnMessage: any;
    lastWarnParams: any[];
    lastErrorMessage: any;
    lastErrorParams: any[];
    lastLogMessage: any;
    lastLogParams: any[];
    checkOnline: any;
    wasOffline: boolean = false;
    initEntered: boolean = false;
    storeOfflineErrors: boolean = false;
    storeOfflineLogs: boolean = true;

    constructor(
        // @Inject(RollbarService) private rollbar: Rollbar,
        // private storage: StorageService, 
        // private http: HttpClient
    ) {
       // this.init();
    }

    init(){
        // if(!this.initEntered){
        //     this.initEntered = true;
        //     App.getInfo().then((appInfo) => {
        //         const appVersion = appInfo.version;
        //         this.rollbar.configure({
        //             codeVersion: appVersion,
        //             code_version: appVersion,
        //             version: appVersion,
        //         });
        //     });

        //     this.storage.get(this.cacheLoggerKey).then(data => {
        //         var logsData = new Array<RollbarLogJson>();
        //         if(data != null){
        //             for (var logMessageJson of data) {
        //                 logsData.push(new RollbarLogJson(logMessageJson.type, logMessageJson.message, logMessageJson.args, logMessageJson.messageType, logMessageJson.argsType));
        //             }
        //         }
        //         this.logsArrayJson = logsData;
        //     });

        //     if(rollbarConfig.enabled && environment.production){
        //         var oldWarn = console.warn;
        //         console.warn = (message?: any, ...optionalParams: any[]) => {
        //             if(rollbarConfig.enabled){
        //                 if(message != this.lastWarnMessage && optionalParams != this.lastWarnParams && message != this.lastErrorMessage && optionalParams != this.lastErrorParams){
        //                     this.lastWarnMessage = message;
        //                     this.lastWarnParams = optionalParams;
        //                     var messageJson = this.getType(message) == "object" ? this.makeJsonFromArgs(message) : message;
        //                     if(optionalParams.length == 0 || optionalParams === undefined){
        //                         oldWarn(message);
        //                         if(this.isOnline()) this.rollbar.warn(messageJson);
        //                         else this.storeLogInCache(RollbarLogType.Warning, messageJson);
        //                     }else{
        //                         var optionalParamsJson = this.makeJsonFromArgs(optionalParams);
        //                         oldWarn(message, optionalParams);
        //                         if(this.isOnline()) this.rollbar.warn(messageJson, optionalParamsJson);
        //                         else this.storeLogInCache(RollbarLogType.Warning, messageJson, optionalParamsJson);
        //                     }
        //                 }
        //             }else{
        //                 if(optionalParams.length == 0 || optionalParams === undefined) oldWarn(message);
        //                 else oldWarn(message, optionalParams);
        //             }
        //         }

        //         var oldError = console.error;
        //         console.error = (message?: any, ...optionalParams: any[]) => {
        //             if(rollbarConfig.enabled){
        //                 if(message != this.lastWarnMessage && optionalParams != this.lastWarnParams && message != this.lastErrorMessage && optionalParams != this.lastErrorParams){
        //                     this.lastErrorMessage = message;
        //                     this.lastErrorParams = optionalParams;
        //                     var messageJson = this.getType(message) == "object" ? this.makeJsonFromArgs(message) : message;
        //                     if(optionalParams.length == 0 || optionalParams === undefined){
        //                         oldError(message);
        //                         if(this.isOnline()) this.rollbar.error(messageJson);//object for 2nd option
        //                         else this.storeLogInCache(RollbarLogType.Error, messageJson);
        //                     }else{
        //                         var optionalParamsJson = this.makeJsonFromArgs(optionalParams);
        //                         oldError(message, optionalParams);
        //                         if(this.isOnline()){
        //                             this.rollbar.error(messageJson, optionalParamsJson);
        //                         }else{
        //                             this.storeLogInCache(RollbarLogType.Error, messageJson, optionalParamsJson);
        //                         }
        //                     }
        //                 }
        //             }else{
        //                 if(optionalParams.length == 0 || optionalParams === undefined) oldError(message);
        //                 else oldError(message, optionalParams);
        //             }
        //         }
        //     }
        // }
    }

    makeJsonFromArgs(args: any[]){
        // var argsProperties = [];
        // if(Array.isArray(args)){
        //     let argsJson: any[] = [];
        //     for(let i=0; i<args.length; i++){
        //         if(args[i] != null) argsProperties = this.getAllObjectProperties(args[i]);
        //         argsJson[i] = args[i] == null ? "" : JSON.stringify(args[i], argsProperties);
        //     }
        //     return argsJson;
        // }else{
        //     let argsJson: any;
        //     if(args != null) argsProperties = this.getAllObjectProperties(args);
        //     argsJson = args == null ? "" : JSON.stringify(args, argsProperties);
        //     return argsJson;
        // }
    }

    isOnline(){
        return localStorage.getItem("RollbarIsOnline") == "true";
        //return this.networkService.userIsOnline2();
    }

    pingRollbar(){
        // return new Promise<any>((resolve, reject) => {
        //     if(rollbarConfig.enabled){
        //         this.postDataRollbar().subscribe(data => {
        //             resolve(data);
        //         },error => {
        //             this.changeEndpoint();
        //             reject(error);
        //         });
        //     }else{
        //         this.changeEndpoint();
        //         resolve([]);
        //     }
        // });
        return null;
    }

    postDataRollbar(): Observable<any> {
        // var url: string = "https://api.rollbar.com/api/1/item/";
        // var paramData: RollbarError = new RollbarError();
        
        // var params = new HttpParams();
        // if (paramData) {
        //     for (var p in paramData) {
        //         params = params.set(p, paramData[p]);
        //     }
        // }
        
        // var headers = new HttpHeaders();
        // headers.append('Content-Type', 'application/json');  
        // headers.append('X-Rollbar-Access-Token', rollbarConfig.accessToken);
        // headers.append('Host', 'api.rollbar.com');
        // headers.append('Sec-Fetch-User', '?1');

        // var params = new HttpParams();

        // return this.http.post(url, paramData, { headers: headers }); //paramData
        return null;
    }

    changeEndpoint(){
        // this.rollbar.configure({
        //     enabled: false,
        //     //endpoint: environment.serviceUrl + "Business/ErrorLoggingRollbar",
        // });
    }

    addRollbarPerson(user, loginResponse) {
        // var loginObj = JSON.parse(loginResponse);
        // this.rollbar.configure({
        //     payload: {
        //         person: {
        //             id: loginResponse["error"] ? 0: "MemberId: "+loginObj.MemberId,
        //             username: user,
        //             email: loginResponse["error"] ? loginResponse["error"] : "UserId: "+loginObj.UserId+" BusinessId: "+loginObj.BusinessId
        //         }
        //     }
        // });
    }
  
    handleError(err: any, ...optionalParams: any[]): void {
        // console.log(err, optionalParams);
        // if(rollbarConfig.enabled && err != this.lastWarnMessage && optionalParams != this.lastWarnParams && err != this.lastErrorMessage && optionalParams != this.lastErrorParams
        //     && err != this.lastLogMessage && optionalParams != this.lastLogParams){
        //     var message = err.originalError || err;
        //     var messageJson = this.getType(message) == "object" ? this.makeJsonFromArgs(message) : message;
        //     if(this.isOnline()){
        //         this.rollbar.error(messageJson);
        //         //this.rollbar.error(err.originalError || err);
        //     }else{
        //         var optionalParamsJson = this.makeJsonFromArgs(optionalParams);
        //         this.storeLogInCache(RollbarLogType.Error, messageJson, optionalParamsJson);
        //     }
        // }
    }

    log(message: any, ...args: Rollbar.LogArgument[]){
        // if(rollbarConfig.enabled){
        //     this.lastLogMessage = message;
        //     this.lastLogParams = args;
        //     var messageJson = this.getType(message) == "object" ? this.makeJsonFromArgs(message) : message;
        //     if(this.isOnline()){
        //         var optionalParamsJson = this.makeJsonFromArgs(args);
        //         this.rollbar.log(messageJson, optionalParamsJson);
        //     }else{
        //         this.storeLogInCache(RollbarLogType.Log, messageJson, args);
        //     }
        // }
    }

    offlineLog(message: any, ...args: Rollbar.LogArgument[]){
        // if(rollbarConfig.enabled){
        //     this.lastLogMessage = message;
        //     this.lastLogParams = args;
        //     var messageJson = this.getType(message) == "object" ? this.makeJsonFromArgs(message) : message;
        //     if(this.isOnline()){
        //         var optionalParamsJson = this.makeJsonFromArgs(args);
        //         this.rollbar.log(messageJson, optionalParamsJson);
        //     }else{
        //         this.storeLogInCache(RollbarLogType.OfflineLog, messageJson, args);
        //     }
        // }
    }

    getAllObjectProperties(object){
       // return Object.getOwnPropertyNames(object).concat(Object.getOwnPropertyNames(Object.getPrototypeOf(object)));
    }

    logsArray: RollbarLog[] = [];
    logsArrayJson: RollbarLogJson[] = [];
    storeLogInCache(type: number, message: any, ...args: Rollbar.LogArgument[]){
        // if((this.storeOfflineErrors && type != RollbarLogType.Log && type != RollbarLogType.OfflineLog) 
        // || ((type == RollbarLogType.Log || type == RollbarLogType.OfflineLog) && this.storeOfflineLogs)){ //to reduce cache size
        //     var newRollbarLog = new RollbarLog(type, message, args);
        //     this.logsArray.push(newRollbarLog);
        //     //console.log("logsArray", this.logsArray);

        //     var newRollbarLogJson = new RollbarLogJson(type, "", [], newRollbarLog.messageType, newRollbarLog.argsType);

        //     var messageProperties = [];
        //     if(newRollbarLog.message != null) messageProperties = this.getAllObjectProperties(newRollbarLog.message);
        //     newRollbarLogJson.message = newRollbarLog.message == null ? "" : JSON.stringify(newRollbarLog.message, messageProperties);
            
        //     var argsProperties = [];
        //     argsProperties = this.makeJsonFromArgs(newRollbarLog.args);
            
        //     this.logsArrayJson.push(newRollbarLogJson);
        //     //console.log("logsArrayJson", this.logsArrayJson);

        //     this.storage.set(this.cacheLoggerKey, this.logsArrayJson);
        // }
    }

    sendLogsToServer(){
        // this.pingRollbar().then(() => {
        //     if(rollbarConfig.enabled){
        //         this.storage.get(this.cacheLoggerKey).then(data => {
        //             if(data != null){
        //                 for(var logMessageJson of data){
        //                     var logMessage: RollbarLog = new RollbarLog(logMessageJson.type, logMessageJson.message == "" ? "" : JSON.parse(logMessageJson.message), logMessageJson.args == "" ? "" : JSON.parse(logMessageJson.args));
        //                     try{
        //                         if(logMessage.args == null){
        //                             logMessage.message = this.removeEmpty(logMessage.message);
        //                             logMessage.message = this.convertBack(logMessage.message, logMessageJson.messageType);
        //                             this.rollbar.log(logMessage.message);
        //                         }else{
        //                             if(Array.isArray(logMessage.args)){
        //                                 for(let i=0; i<logMessage.args.length; i++){
        //                                     logMessage.args[i] = this.convertBack(logMessage.args[i], logMessageJson.argsType[i]);
        //                                 }
        //                             }else{
        //                                 logMessage.args = this.convertBack(logMessage.args, logMessageJson.argsType);
        //                             }
        //                             logMessage.message = this.convertBack(logMessage.message, logMessageJson.messageType);
        //                             this.rollbar.log(logMessage.message, logMessage.args);
        //                         }
        //                     }catch(ex){
        //                         console.log("Offline log sending exception: ", ex);
        //                     }
        //                 }
        //             }
        //             this.storage.remove(this.cacheLoggerKey);
        //         });
        //     }
        // }).catch(e => { this.customLog("Rollbar Error: ", e); });
    }

    removeEmpty(obj) {
        // for (var propName in obj) {
        //     if (obj[propName] === null || obj[propName] === undefined || Object.keys(obj[propName]).length === 0){
        //         if(isNaN(obj[propName])){
        //             //delete obj[propName];
        //             obj[propName] = "";
        //         }
        //     }
        // }
        // return obj;
    }

    assignProperties(newObj, objectProperties, object){
        // for(var name of objectProperties){
        //     newObj[name]=object[name];
        // }
        // return newObj;
    }
    convertBack(object, type){
        // var objectProperties = this.getAllObjectProperties(object);
        // switch(type){
        //     case "Error":
        //         var newError = new Error("");
        //         newError = this.assignProperties(newError, objectProperties, object);
        //         return newError;
        //     case "Date":
        //         var newDate = new Date("");
        //         newDate = this.assignProperties(newDate, objectProperties, object);
        //         return newDate;
        //     case "Callback":
        //     case "object":
        //         return JSON.stringify(object, objectProperties);
        //     case "string":
        //         return object;
        //     default:
        //         return object.toString();
        // }
    }

    getType(object: any){
        // var variableTypes: string[] = ["Error", "Callback", "Date"];
        // if(typeof(object) == "object"){
        //     if(object instanceof Error) return "Error";
        //     else if(object instanceof Date) return "Date";
        //     else if(object.hasOwnProperty("constructor")){
        //         if(object.constructor.hasOwnProperty("name")) return variableTypes.findIndex(object.constructor.name) >=0 ? object.constructor.name : "object";
        //     }
        //     return "object";
        // }else return typeof(object);
    }

    debugging: boolean = false;
    customLog(message?: any, ...optionalParams: any[]){
        // if(this.debugging){
        //     if(optionalParams !== undefined && optionalParams.length != 0){
        //         console.log(message, optionalParams);
        //     }else{
        //         console.log(message);
        //     }
        // }
    }
}
  
export function rollbarFactory() {
    return new Rollbar(rollbarConfig);
}

enum RollbarLogType{
    Critical = 1,
    Error = 2,
    Warning = 3,
    Info = 4,
    Log = 4,
    Debug = 5,
    OfflineLog = 6
}
export class RollbarLog{
    type: number;
    message: any;
	args: any[];// Rollbar.LogArgument[];
    messageType: string;
    argsType: string[];

    constructor(type, message, args){
        // this.type = type;
        // this.message = message;
        // if(args.length == 1){
        //     if(args[0].length == 0) args = "";
        // }
        // this.args = (args == null || args === undefined || args.length == 0) ? null : args;
        // this.messageType = this.getType(message);
        // if(Array.isArray(args)){
        //     this.argsType = [];
        //     for(let i=0; i<args.length; i++){
        //         this.argsType[i] = this.getType(args[i]);
        //     }
        // }else{
        //     this.argsType = this.getType(args);
        // }
    }

    getType(object: any){
        // var variableTypes: string[] = ["Error", "Callback", "Date"];
        // //string | Error | object | Callback | Date | any[] | undefined;
        // //'"string" | "number" | "bigint" | "boolean" | "symbol" | "undefined" | "object" | "function"'
        // if(typeof(object) == "object"){
        //     if(object instanceof Error) return "Error";
        //     else if(object instanceof Date) return "Date";
        //     else if(object.hasOwnProperty("constructor")){
        //         if(object.constructor.hasOwnProperty("name")) return variableTypes.findIndex(object.constructor.name) >=0 ? object.constructor.name : "object";
        //     }
        //     return "object";
        // }else return typeof(object);
    }
}
export class RollbarLogJson{
    type: number;
    message: string;
	args: string;
    messageType: string;
    argsType: string[];

    constructor(type, message, args, messageType, argsType){
        // this.type = type;
        // this.message = message;
        // this.args = args;
        // this.messageType = messageType;
        // this.argsType = argsType;
    }
}